import FeedbackIcon from '@mui/icons-material/Feedback';
import { Fab, Tooltip } from '@mui/material';
import useStore from '../stores';
import { useFeedbackDialogStore } from '../stores/feedbackDialogStore';

/**
 * Floating action button (bottom-left) that opens the feedback dialog.
 * Bottom-left is intentional: the prod accessibility widget occupies bottom-right.
 *
 * Auth signal: useStore (persisted Zustand) — userProfile.email is non-empty only
 * when an authenticated session has loaded the profile. The authSlice in
 * authSlice.ts is unused in production; useStore is the single source of truth.
 *
 * Only renders when the user is authenticated. The dialog itself is rendered
 * once at App.tsx and triggered via useFeedbackDialogStore.
 */
function FeedbackButton() {
  // Non-empty email means an authenticated profile is loaded
  const userEmail = useStore((state) => state.userProfile.email);
  const setOpen = useFeedbackDialogStore((s) => s.setOpen);

  if (!userEmail) {
    return null;
  }

  return (
    <Tooltip title="Send feedback" placement="right">
      <Fab
        aria-label="Send feedback"
        onClick={() => setOpen(true)}
        sx={{
          position: 'fixed',
          bottom: 16,
          left: 16,
          zIndex: (theme) => theme.zIndex.tooltip - 1,
          bgcolor: 'common.black',
          color: 'common.white',
          '&:hover': { bgcolor: 'grey.900' },
        }}
      >
        <FeedbackIcon />
      </Fab>
    </Tooltip>
  );
}

export default FeedbackButton;
